import React from 'react';
import { useContextFactory } from 'utils';

const CustomizationContext = React.createContext({});
const useCustomizationContext = () => useContextFactory('CustomizationContext', CustomizationContext);

export { CustomizationContext, useCustomizationContext };
